// extracted by mini-css-extract-plugin
export default {"shad":"UpdateReq_shad__LjUCM","popupWidth":"UpdateReq_popupWidth__M7wOa","crsr":"UpdateReq_crsr__GnK1r","bg-main":"UpdateReq_bg-main__TfZWG","mainColor":"UpdateReq_mainColor__3Zsqb"};